import type { IExpectedHoursItem } from "../../services/types/expectedHours";
import type { WorktimeSettlementStatus } from "../../services/types/worktimeSettlement";

type RowTone = "neutral" | "attention";

type ComplianceIconKind = "consistent" | "inconsistent";

type ComplianceMeta = {
  iconKind: ComplianceIconKind;
  label: string;
};

type DecisionBadgePresentation = {
  label: string;
  color: "informative" | "success" | "danger";
  appearance: "tint";
};

const DECISION_BADGE_PRESENTATION: Record<WorktimeSettlementStatus, DecisionBadgePresentation> = {
  pending: { label: "Oczekuje", color: "informative", appearance: "tint" },
  accepted: { label: "Zaakceptowano", color: "success", appearance: "tint" },
  rejected: { label: "Odrzucono", color: "danger", appearance: "tint" },
};

export function resolveAdminDecision(item: IExpectedHoursItem): WorktimeSettlementStatus {
  return item.settlementStatus ?? "pending";
}

export function resolveRowTone(item: IExpectedHoursItem): RowTone {
  const decision = resolveAdminDecision(item);
  if (decision === "rejected") return "attention";
  if (decision === "pending" && !item.isValuesConsistent) return "attention";
  return "neutral";
}

export function getComplianceMeta(item: IExpectedHoursItem): ComplianceMeta {
  const decision = resolveAdminDecision(item);
  const ok = item.isValuesConsistent;

  if (ok && decision === "pending") {
    return { iconKind: "consistent", label: "Dane zgodne" };
  }
  if (!ok && decision === "pending") {
    return { iconKind: "inconsistent", label: "Wykryto rozbieżność" };
  }
  if (ok && decision === "accepted") {
    return { iconKind: "consistent", label: "Dane zgodne" };
  }
  if (!ok && decision === "accepted") {
    return { iconKind: "inconsistent", label: "Zaakceptowano mimo rozbieżności" };
  }
  if (ok && decision === "rejected") {
    return { iconKind: "consistent", label: "Dane zgodne" };
  }
  return { iconKind: "inconsistent", label: "Odrzucono z rozbieżnością" };
}

export function resolveDecisionBadgePresentation(
  decision: WorktimeSettlementStatus
): DecisionBadgePresentation {
  return DECISION_BADGE_PRESENTATION[decision];
}
